import { useEffect, useCallback } from 'react'
import { canUseWindow } from '@/utils/browser'

interface IUseOnTabClose {
  callback?: CallableFunction
  useConfirm: boolean
  condition?: boolean
}

const useOnTabClose = ({
  callback,
  useConfirm,
  condition = true,
}: IUseOnTabClose) => {
  const isNotCypress = canUseWindow && !window?.Cypress

  const handleBeforeunload = useCallback(
    (e: BeforeUnloadEvent) => {
      e.preventDefault()

      if (typeof callback === 'function') {
        callback()
      }

      if (isNotCypress && useConfirm) {
        return (e.returnValue = '')
      }
    },
    [useConfirm, callback, isNotCypress]
  )

  useEffect(() => {
    if (condition) {
      window.addEventListener('beforeunload', handleBeforeunload)

      return () => {
        window.removeEventListener('beforeunload', handleBeforeunload)
      }
    }
  }, [condition, handleBeforeunload])

  return null
}

export default useOnTabClose
